import script from "./Blog.vue?vue&type=script&lang=ts&setup=true"
export * from "./Blog.vue?vue&type=script&lang=ts&setup=true"

import "../assets/css/style.css?vue&type=style&index=0&id=5b7a29b0&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b7a29b0"]])

export default __exports__